export default {
  add_items: 'Add items',
  remove_items: 'Remove items',
  place_order: 'Place order',
  pay_now: 'Pay now',

  terms:
    'By placing your order, you agree to our <TermsLink>Terms and Conditions</TermsLink> and our <PrivacyPolicyLink>Privacy Policy</PrivacyPolicyLink>.',

  modals: {
    account_switch: {
      title: 'Account with phone number {{phoneNumber}} already exists',
      description: 'We carefully logged you in to the existing account, while keeping the info that you entered 😊',
      button: 'Proceed',
    },
  },

  error_messages: {
    payment_unsuccessful: {
      title: 'Payment failed',
      description: 'Please check your payment information and try again.',
    },
  },

  toasts: {
    input_errors_found: 'There are some issues with the your order info',
  },
};
